import { callSelectors } from '@lifesize/nucleus';
import { createSelector } from 'reselect';
import actions from 'actions/AddParticipantDrawer';
import { Observer } from '@lifesize/web-clients-core';

const initialData = {
  inviteeLength: 0
};

const activeCallSelector = state => callSelectors.activeCallSelector(state);
const inviteeSelector = createSelector([activeCallSelector],
  activeCall => ({ inviteeLength: activeCall.invitees.length })
);

const handler = (oldData, newData, dispatch) => {
  if (oldData.inviteeLength !== 0 && newData.inviteeLength === 0) {
    dispatch(actions.clearAddList());
  }
};

export const handlerMethods = [inviteeSelector, initialData, handler];
export default Observer.createObserver(...handlerMethods);
